export { default as Icon, type IconProps } from './Icon';
